import React from "react";
import DeleteButtonWithConfirmation from "../FormInputs/DeleteButtonWithConfirmation/DeleteButtonWithConfirmation";
import BowlingCenterInfo from "./BowlingCenterInfo";

const SelectedCenters = ({
  selectedCenters,
  onRemoveCenter,
  isLoggedIn,
  canManage,
}) => {
  if (!selectedCenters.length) {
    return (
      <div className="text-brand-muted italic">No bowling centers selected</div>
    );
  }

  return (
    <div className="mb-6">
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        {selectedCenters.map((center) => (
          <div key={center.id} className="card-inset p-4">
            <BowlingCenterInfo
              center={center.bowlingCenters}
              nameClassName="font-display font-bold text-brand-charcoal hover:underline"
            />
            {canManage && (
              <div className="mt-3">
                <DeleteButtonWithConfirmation
                  itemId={center.bowlingCenterId}
                  onDelete={onRemoveCenter}
                />
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default SelectedCenters;
